<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Benefit Type</h5>
      <br />
      <b-row>
        <b-col md="2" class="my-1">
          <b-form inline>
            Show &nbsp;
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
            &nbsp; Records
          </b-form>
        </b-col>
        <b-col class="text-right">
          <router-link :to="{name: 'createBenefitType'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="benefitType"
        :items="getInfo"
        :fields="types"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="{ item }">
          <p class="mb-0">{{item.created_at | DateTime}}</p>
        </template>
        <template v-slot:cell(updated_at)="{ item }">
          <div v-if="item.updated_at">
            <p class="mb-0">{{item.updated_at | DateTime}}</p>
          </div>
          <div v-else>
            -
          </div>
        </template>
        <template v-slot:cell(action)="{item}">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editBenefitType', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      types: [
        {
          key: "created_at",
          label: "Created",
          sortable: false,
          class: "text-left"
        },
        {
          key: "type_category_benefit.display",
          label: "Category",
          sortable: false,
          class: "text-left"
        },
        {
          key: "display",
          label: "Type English",
          sortable: false,
          class: "text-left"
        },
        {
          key: "display_id",
          label: "Type Bahasa",
          sortable: false,
          class: "text-left"
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("BenefitTypeModule/getBenefitTypesWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.count;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.type_benefits || [];
          callback(response.data.data.type_benefits || []);
          this.loading = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("BenefitTypeModule/deleteBenefitType", id)
          .then((response) => {
            this.$refs.benefitType.refresh();
            this.$swal("Deleted!", "Your data has been deleted.", "success");
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            console.log(error);
          });
        }
      });
    }
  }
};
</script>

<style>
</style>
